var exports = {
  "kL": "xcc377c0b--f7f438--container",
  "uH": "xcc377c0b--f7f438--details-title",
  "ZQ": "xcc377c0b--f7f438--items-container",
  "AS": "xcc377c0b--f7f438--item",
  "DD": "xcc377c0b--f7f438--title",
};

module.exports = exports;
